import React from 'react';

const SimpleText = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#F0CBC7" />
    <line x1="4" y1="10.5" x2="14" y2="10.5" stroke="black" />
    <line x1="10" y1="13.5" x2="20" y2="13.5" stroke="black" />
    <line x1="16" y1="10.5" x2="20" y2="10.5" stroke="black" />
    <line x1="4" y1="13.5" x2="8" y2="13.5" stroke="black" />
  </svg>
);

export default SimpleText;
